export const SET_DATATABLE_FILTERS = 'SET_DATATABLE_FILTERS';